import { CarouselEvent } from "@/components/Carousel/Event"
import { Meta } from "@/components/meta/Meta"
import { getPage } from "@/data/get-page-by-id"
import { BreadcrumbWithCover } from "@/layout/BreadcrumbWithCover"
import { News } from "@/modules/blog/components/News"
import { Button, Container, Flex } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import { useTranslation } from "next-i18next"
import { FC } from "react"

interface Props {
  page: Awaited<ReturnType<typeof getPage>>
}

export const Blog: FC<Props> = ({ page }) => {
  const isResponsive = useMediaQuery("(max-width: 48em)")
  const { t } = useTranslation("common")

  return (
    <>
      <Meta data={page?.attributes?.seo!} />
      <BreadcrumbWithCover
        cover={page?.attributes?.seo?.metaImage?.data?.attributes?.url}
        title={page?.attributes?.title!}
        breadcrumbs={[{ title: page?.attributes?.title!, url: "/news" }]}
      />
      <Container mb={94}>
        <Flex p={0} m={0} mt={{ base: 30, sm: 48 }} direction={"column"}>
          <CarouselEvent />

          <News />

          <Button
            style={{ margin: "44px auto 0", display: "none" }}
            mt={44}
            bg={"#F7F7F7"}
            c={"#000000"}
            w={220}
            h={52}
            variant="filled"
          >
            {t("Load more", "Load more")}
          </Button>
        </Flex>
      </Container>
    </>
  )
}
